// @ngInject
function stateConfig($stateProvider) {
  $stateProvider.state("stock.modelinventorysearch.modelinventory", {
    url: "/{articleId}",
    views: {
      "articleView@stock": {
        templateUrl:
          "main/stock/articles/modelinventory/modelinventory.tpl.html",
        controller: "StockModelInventoryController as vm",
      },
    },

    resolve: {
      article: articleResolver,
      stocks: stocksResolver,
      inventoriesCount: getPendingInventoryCountResolver,
    },
  });
}

// @ngInject
function articleResolver($stateParams, StockApiService) {
  return StockApiService.getProduct($stateParams.articleId);
}

// @ngInject
function stocksResolver($stateParams, StockApiService) {
  return StockApiService.getProductStock($stateParams.articleId);
}

// @ngInject
function getPendingInventoryCountResolver($stateParams, InventoryingApiService) {
  return InventoryingApiService.getPendingInventoryCount($stateParams.articleId);
}

// @ngInject
function StockModelInventoryController(
  $window,
  $state,
  $translate,
  $timeout,
  $scope,
  AuthService,
  article,
  stocks,
  inventoriesCount,
  StockApiService,
  ToasterService,
  loadSpinnerService,
  ArticleLabelsPrintDialogService,
  InventoryingApiService
) {
  var vm = this;
  var rowData = [];
  var rowCollection = new wijmo.collections.CollectionView(rowData);
  var flexGrid = {};
  var flexGridCurrentlySelectedItem = {};
  var originalCellValue = "";

  var totalsGrid = {};

  vm.processingSaveChanges = false;
  vm.selectedArticle = article;
  vm.stocksData = stocks;
  vm.inventoriesPending = inventoriesCount.data;
  vm.stocksLocations = pickOutUniqueLocations(vm.stocksData);
  vm.selectedLocation = {};
  vm.totals = [
    {
      sumName: "Total",
      theoreticalTotal: 0,
      inventoriedTotal: 0,
      difference: 0,
    },
  ];

  vm.inventory = {
    inventoryDescription: "",
    deliverImmediately: true,
    location: vm.selectedLocation,
    article: vm.selectedArticle,
    inventoryDate: new Date(),
    inventoryRows: [],
  };

  vm.canAccess = AuthService.canAccess;
  vm.mayReadStockLogistics = AuthService.canAccess("stockLogistics", "read");
  vm.captureVariantsGrid = captureVariantsGrid;
  vm.beginEditing = beginEditing;
  vm.editEnded = editEnded;
  vm.selectedLocationChanged = selectedLocationChanged;
  vm.zeroAllQuantities = zeroAllQuantities;
  vm.captureTotalsGrid = captureTotalsGrid;
  vm.contextMenuZeroRow = contextMenuZeroRow;
  vm.saveChanges = saveChanges;
  vm.openLabelsModal = openLabelsModal;
  vm.productStateGo = productStateGo;
  vm.saveButtonDisable = saveButtonDisable;

  activate();

  function saveButtonDisable()
  {
    return vm.inventoriesPending.count > 0
  }

  function activate() {
    $window.addEventListener("click", hideContextMenuListener);

    StockApiService.getFilteredLocations().then(
      function (response) {
        vm.stocksLocations = response;
      },
      function (error) {
        console.log(error);
      }
    );
  }

  function pollPendingInventoryCount(isNewInventory) {
    var loadTime = 5000, //Load the data every 5 second
      loadPromise;

    var getData = function () {
      InventoryingApiService.getPendingInventoryCount(
        vm.selectedArticle.id
      ).then(
        function (response) {
          vm.inventoriesPending = response.data;
          if (response.data.count === 0) {
            cancelNextLoad();
            $state.reload();
            ToasterService.showInfo(
              $translate.instant("common.done"),
              $translate.instant("stock.inventorymodel")
            );

            return;
          }
          nextLoad();
        },
        function (error) {
          console.log(error);
        }
      );
    };

    var cancelNextLoad = function () {
      $timeout.cancel(loadPromise);
    };

    var nextLoad = function () {
      //Clear timeout
      cancelNextLoad();
      loadPromise = $timeout(getData, loadTime);
    };

    //Start polling the data from the server
    getData();

    $scope.$on("$destroy", function () {
      cancelNextLoad();
    });
  }

  function captureTotalsGrid(sender) {
    totalsGrid = sender;

    // Setting the item formatter, coloring the first line (total sum) differently.
    totalsGrid.itemFormatter = function (panel, r, c, cell) {
      var style = cell.style;
      var regularCellType = wijmo.grid.CellType.Cell;

      if (r === 0 && panel.cellType === regularCellType) {
        style.color = "#000000";
        style.backgroundColor = "#dddddd";
      }
    };
  }

  function openLabelsModal() {
    ArticleLabelsPrintDialogService.showDialog(vm.selectedArticle.id);
  }

  function saveChanges() {
    if(vm.processingSaveChanges)
      return;

    vm.processingSaveChanges = true;
    vm.inventory.inventoryRows = [];

    _.forEach(rowData, function (data) {
      var keys = Object.keys(data);
      var variant1Name = data["variantDetails1Name"];
      _.forEach(keys, function (key) {
        if (key !== "variantDetails1Name") {
          var relatedArticleVariant = _.find(
            vm.selectedArticle.articleVariants,
            function (articleVariant) {
              return (
                articleVariant.variantDetail1.variantDetailName ===
                  variant1Name &&
                articleVariant.variantDetail2.variantDetailName === key
              );
            }
          );

          var specifiedQuantity = data[key].split("(")[0].trim();

          var inventoryRow = {
            articleVariant: relatedArticleVariant,
            quantity: parseInt(specifiedQuantity),
          };

          vm.inventory.inventoryRows.push(inventoryRow);
        }
      });
    });

    loadSpinnerService.start("mainSpinner");
    StockApiService.saveProductInventory(vm.inventory)
      .then(
        function (response) {
          ToasterService.showInfo(
            $translate.instant("stock.inventorybeingprocessed"),
            $translate.instant("stock.inventorymodel")
          );
          //$state.reload();
        },
        function (error) {
          console.log(error);
          ToasterService.showError(
            $translate.instant(error.message),
            $translate.instant("common.error")
          );
        }
      )
      .finally(function () {
        // $state.reload();
        pollPendingInventoryCount(true);
        loadSpinnerService.stop("mainSpinner");
        vm.processingSaveChanges = false;
      });
  }

  function zeroAllQuantities() {
    _.forEach(rowData, function (data) {
      var keys = Object.keys(data);
      _.forEach(keys, function (key) {
        if (key !== "variantDetails1Name") {
          var dataContents = data[key].split("(");
          data[key] = 0 + " (" + dataContents[1];
        }
      });
    });

    flexGrid.invalidate();
    calculateNewTotals();
  }

  function calculateNewTotals() {
    var totalsObject = _.find(vm.totals, function (totalsEntry) {
      return totalsEntry.sumName === "Total";
    });

    totalsObject.theoreticalTotal = 0;
    totalsObject.inventoriedTotal = 0;
    totalsObject.difference = 0;

    _.forEach(rowData, function (data) {
      var keys = Object.keys(data);
      var variant1TotalsObject = _.find(vm.totals, function (variant1Entry) {
        return variant1Entry.sumName === data["variantDetails1Name"];
      });
      if (variant1TotalsObject === undefined) {
        variant1TotalsObject = {
          sumName: data["variantDetails1Name"],
          theoreticalTotal: 0,
          inventoriedTotal: 0,
          difference: 0,
        };
        vm.totals.push(variant1TotalsObject);
      }

      variant1TotalsObject.theoreticalTotal = 0;
      variant1TotalsObject.inventoriedTotal = 0;
      variant1TotalsObject.difference = 0;

      _.forEach(keys, function (key) {
        if (key !== "variantDetails1Name") {
          var currentData = data[key].split("(");
          currentData[1] = currentData[1].substring(
            0,
            currentData[1].length - 1
          );

          totalsObject.theoreticalTotal += parseInt(currentData[1]);
          totalsObject.inventoriedTotal += parseInt(currentData[0]);

          variant1TotalsObject.theoreticalTotal += parseInt(currentData[1]);
          variant1TotalsObject.inventoriedTotal += parseInt(currentData[0]);

          variant1TotalsObject.difference =
            variant1TotalsObject.inventoriedTotal -
            variant1TotalsObject.theoreticalTotal;
        }
      });
    });

    totalsObject.difference =
      totalsObject.inventoriedTotal - totalsObject.theoreticalTotal;
    if (totalsGrid.collectionView) {
      totalsGrid.collectionView.refresh();
    }
  }

  function beginEditing(sender, e) {
    var rowNumber = flexGrid.selection.row;
    var columnNumber = flexGrid.selection.col;

    var columnHeader = flexGrid.columns[columnNumber].binding;

    originalCellValue = angular.copy(rowData[rowNumber][columnHeader]);

    rowData[rowNumber][columnHeader] = rowData[rowNumber][columnHeader]
      .split("(")[0]
      .trim();
    rowCollection.refresh();
  }

  function editEnded(sender, e) {
    var rowNumber = flexGrid.selection.row;
    var columnNumber = flexGrid.selection.col;

    var columnHeader = flexGrid.columns[columnNumber].binding;

    // Reinserting the parenthesis value.
    rowData[rowNumber][columnHeader] =
      rowData[rowNumber][columnHeader] + " (" + originalCellValue.split("(")[1];
    rowCollection.refresh();
    calculateNewTotals();
  }

  function selectedLocationChanged(sender) {
    if (!sender.selectedItem) {
      return;
    }

    vm.selectedLocation = _.find(vm.stocksLocations, function (location) {
      return location.id === sender.selectedItem.id;
    });

    vm.inventory.location = vm.selectedLocation;
    initializeGridColumns();
  }

  function initializeGridColumns() {
    // Need to wait for the grid to be initialized
    if (!flexGrid.columns) {
      setTimeout(initializeGridColumns, 100);
      return;
    }

    rowData.length = 0;
    flexGrid.columns.clear();
    rowCollection.refresh();

    // Add first row header column
    var rowHeader = new wijmo.grid.Column();
    rowHeader.binding = "variantDetails1Name";
    rowHeader.header = " ";
    rowHeader.allowSorting = false;
    rowHeader.width = 100;
    rowHeader.isReadOnly = true;
    flexGrid.columns.push(rowHeader);

    var columns = getDataColumns();

    // Add dynamic columns
    _.forEach(columns, function (variantDetail) {
      var c = new wijmo.grid.Column();
      c.binding = variantDetail.variantDetailName;
      c.header = variantDetail.variantDetailName;
      c.width = "*";
      c.allowSorting = false;
      c.inputType = "text";
      c.isReadOnly = false;
      c.align = "right";
      flexGrid.columns.push(c);
    });

    loadGridData();
  }

  function captureVariantsGrid(sender) {
    flexGrid = sender;

    flexGrid.initialize({
      autoGenerateColumns: false,
      selectionMode: wijmo.grid.SelectionMode.Cell,
      allowDragging: wijmo.grid.AllowDragging.None,
      allowResizing: wijmo.grid.AllowResizing.None,
      headersVisibility: wijmo.grid.HeadersVisibility.Column,
      isReadOnly: false,
      itemsSource: rowCollection,
    });

    initializeGridColumns();

    var host = flexGrid.hostElement;
    host.addEventListener("contextmenu", contextMenuListener);
  }

  function getDataColumns() {
    var columns = [];

    // Group by nested variantDetail2 in the current articleVariants
    columns = _.groupBy(vm.selectedArticle.articleVariants, function (variant) {
      return variant.variantDetail2.variantDetailName;
    });
    // Get the variantDetail2 from each group in an array
    columns = _.reduce(
      columns,
      function (newArray, val, key) {
        newArray.push(val[0].variantDetail2);
        return newArray;
      },
      []
    );

    return _.sortBy(columns, "sortOrder");
  }

  function loadGridData() {
    var articleVariants = _.groupBy(
      vm.selectedArticle.articleVariants,
      function (articleVariant) {
        return articleVariant.variantDetail1.variantDetailName;
      }
    );

    _.forEach(articleVariants, function (variantRowValues) {
      var r = {};
      _.forEach(variantRowValues, function (variantRowValue) {
        r.variantDetails1Name =
          variantRowValue.variantDetail1.variantDetailName;

        var relatedStock = getStockFor(
          r.variantDetails1Name,
          variantRowValue.variantDetail2.variantDetailName
        );

        if (
          relatedStock === undefined ||
          relatedStock.location.id !== vm.selectedLocation.id
        ) {
          relatedStock = {};
          relatedStock["quantity"] = 0;
        }

        r[variantRowValue.variantDetail2.variantDetailName] =
          relatedStock.quantity + " (" + relatedStock.quantity + ")";
      });
      rowData.push(r);
    });
    rowCollection.refresh();

    calculateNewTotals();
  }

  function getStockFor(variantDetail1Name, variantDetail2Name) {
    return _.find(vm.stocksData, function (stock) {
      return (
        stock.articleVariant.variantDetail1.variantDetailName ===
          variantDetail1Name &&
        stock.articleVariant.variantDetail2.variantDetailName ===
          variantDetail2Name &&
        stock.location.id === vm.selectedLocation.id
      );
    });
  }

  function pickOutUniqueLocations(stocks) {
    var locations = [];
    _.each(stocks, function (stock) {
      var unique = true;
      _.each(locations, function (location) {
        if (location.id === stock.location.id) {
          unique = false;
        }
      });
      if (unique) {
        locations.push(stock.location);
      }
    });
    return locations;
  }

  function contextMenuZeroRow() {
    console.log(flexGridCurrentlySelectedItem);
    var keys = Object.keys(flexGridCurrentlySelectedItem);

    _.forEach(keys, function (key) {
      if (key !== "variantDetails1Name") {
        console.log("Current key: " + key);
        console.log(flexGridCurrentlySelectedItem[key]);
        var oldValue = flexGridCurrentlySelectedItem[key].split("(");

        flexGridCurrentlySelectedItem[key] = 0 + " (" + oldValue[1];
      }
    });

    flexGrid.invalidate();
    calculateNewTotals();
  }

  function hideContextMenuListener(e) {
    var jqContextMenu = $("#inventoryContextMenu");
    jqContextMenu.css("visibility", "hidden");
  }

  function contextMenuListener(event) {
    var sel = flexGrid.selection;
    var clickedRowNumber = sel.row;
    var jqContextMenu = $("#inventoryContextMenu");

    event.preventDefault();
    flexGridCurrentlySelectedItem = rowData[clickedRowNumber];

    jqContextMenu.css("left", event.clientX);
    jqContextMenu.css("top", event.clientY);
    jqContextMenu.css("visibility", "visible");
  }

  function productStateGo(stringState) {
    if(typeof cancelNextLoad === 'function'){
      cancelNextLoad();
    }
    $state.go(stringState, {
      articleId: vm.selectedArticle.id,
      filter: $state.params.filter,
      currentPage: $state.params.currentPage,
      pageSize: $state.params.pageSize,
      inactive: $state.params.inactive,
      match: $state.params.match,
    },
    {reload:true});
  }
}

angular
  .module("stock.articles.modelinventory", [])
  .config(stateConfig)
  .controller("StockModelInventoryController", StockModelInventoryController);
